import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  DashboardService,
  EMD_ASSET_BASE,
  EMD_ASSET_BUCKET,
  EMD_DASHBOARD_KEY,
  EMD_DASHBOARD_NM,
  SALES_MODULE_KEY,
  CaseManagementDashboard,
  FRM_CASE_MANAGEMENT_DASHBOARDS,
  FRM_MODULE_KEY,
} from "src/app/services/dashboard.service";
import { SessionService } from "src/app/services/session.service";
import { DataService } from "src/app/services/data.service";
import { FilterService } from "src/app/services/filter.service";
import { debounceTime, Subscription } from "rxjs";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { MatDialog } from "@angular/material/dialog";
import { SelectionPopupComponent } from "../shared/selection-popup/selection-popup.component";
import { ConstantsService } from "src/app/services/constants.service";
import { UserActivityService } from "src/app/services/useractivity.service";
import { ApiService } from "src/app/services/api.service";
import { NavigationService } from "src/app/services/navigation.service";
import { WidgetService } from "src/app/services/widget.service";
import {
  STATIC_DASHBOARDS,
  isStaticDashboardKey,
} from "./static/static-dashboards";
import { markStaticDashboardEntry } from "./static/static-dashboard-entry";

@Component({
    selector: "app-dashboard",
    templateUrl: "./dashboard.component.html",
    styleUrls: ["./dashboard.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy {
  userName: string = "";
  clientKey: any;
  moduleKey: any;
  module: any;
  pages: any;
  title: any;
  logoImage: any;
  colorCodes: any = [];
  colors: any;
  pageLogo: any;
  pageInfo: any;
  selectConfig!: any;
  DbPages: any;
  newColor: any;
  clientLogo: any;
  checkFlag = true;

  brandKeyData: any[] = [];
  test: any;
  page_nm: any;
  reqSubcription: Subscription[] = [];
  moduleName: any;

  // for Auto Complete

  @ViewChild("brandkeySelection", { static: true })
  brandkeySelection!: ElementRef;

  constructor(
    private dashboardService: DashboardService,
    private sessionService: SessionService,
    private router: ActivatedRoute,
    private route: Router,
    private dataService: DataService,
    private navigationService: NavigationService,
    private dialog: MatDialog,
    private apiService: ApiService,
    public filterService: FilterService,
    public deviceDetectionService: DeviceDetectionService,
    private constantsService: ConstantsService,
    private userActivityService: UserActivityService,
    private cdr: ChangeDetectorRef,
    private widgetService: WidgetService
  ) {}

  isIpad = false;
  ngOnInit(): void {
    // Router
    this.router.params.subscribe((p) => {
      this.moduleName = p["module"] || "";

      this.router.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);

        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];
      });

      // FRMCRM has no dashboards: its home is Case Management's landing page,
      // which the topnav logo reaches through this route.
      if (this.clientKey && this.dashboardService.isFrmCrmModule(this.moduleKey, this.moduleName)) {
        this.dashboardService.openFrmCrm(this.clientKey, this.moduleKey, this.moduleName, true);
        return;
      }

      if (this.clientKey) {
        this.newColor = this.sessionService.getColorCodes();
        this.userName = this.sessionService.getUsername();

        // Brand Name
        // this.getBrandName()

        this.filterService.refreshData = false;
        // this.filterService.refreshTheDashboard = false;
        // get data from sessionservice
        this.selectConfig = sessionStorage.getItem("selectConfig");

        // for user menu icons color css classes.
        this.dashboardService.moduleKey = this.moduleKey;

        // FRM Portal Brand key Selections
        // if (this.moduleKey == '100110') {
        //   setTimeout(() => {
        //     this.pages = [];
        //     let getBrand:any = sessionStorage.getItem("brandKeyForFilters");

        //     if (!getBrand) {
        //       this.checkFlag = false;
        //       this.gettingDatafromPopup();
        //     } else {
        //       this.checkFlag = true;
        //       this.getDashboardData();
        //       this.clientLogo = this.filterService.getBrandLogo({brand_key: getBrand});
        //     }
        //   }, 500);
        // } else {
        //   this.getDashboardData();
        //   sessionStorage.removeItem("tbl_name_suffix");
        //   this.clientLogo = this.sessionService.getClintLogo();
        // }

        this.getDashboardData();
        sessionStorage.removeItem("tbl_name_suffix");
        this.clientLogo = this.sessionService.getClintLogo();

        this.cdr.detectChanges();
        if (this.selectConfig == "DB") {
          this.getWorknames();
        } else {
          this.selectConfig = "S3";
        }
      }
    });

    // if(this.clientKey) {
    //   // get Logos
    //   this.apiService.getlogos().subscribe((res:any)=>{
    //     // console.log(res)
    //     if(res.length>0){
    //       sessionStorage.setItem('logos', JSON.stringify(res))
    //     }else{
    //       alert(" brand logos not found")
    //     }
    //   },(err:any)=>{alert(" brand logos not found")})
    // }
  }

  gettingDatafromPopup() {
    this.dialog.closeAll();

    let dialogRef = this.dialog.open(SelectionPopupComponent, {
      width: this.constantsService.MEDIUM_DIALOG_BOX_WIDTH,
      disableClose: true,
      panelClass: "du-custom-modalbox",
    });

    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.setBrandKey(value?.brand_key);
        sessionStorage.setItem("tbl_name_suffix", JSON.stringify(value));
      }
    });
  }

  getDashboardData() {
    let body = {
      username: this.userName,
      client_key: this.clientKey,
      module_key: this.moduleKey,
    };

    if (this.dashboardService.menuItems?.length > 0) {
      let fndModule = this.dashboardService.menuItems.find(
        (f: any) => f.access_flg == "Y" && this.moduleKey == f.module_key
      );
      if (fndModule) {
        this.dashboardService.userMenuModuleHandle(false, fndModule);
      }
    }

    this.reqSubcription.push(
      this.dashboardService
        .getDashboardAccess(body)
        .pipe(debounceTime(500))
        .subscribe(
          (dashboard) => {
            if (dashboard != null) {
              this.pages = dashboard;

              // The EMD Wholesaler Dashboard is a static prototype: dashboard
              // access has no row for it yet, so append its tile to the Sales
              // module's real dashboards.
              if (this.moduleKey == SALES_MODULE_KEY) {
                this.pages.push(this.buildEmdPage());
              }
              this.appendCaseManagementPages();
              //  if (this.moduleKey == 100101) {
              //   this.pages.push({
              //         "dashboard_key": "20260811121000",
              //         "dashboard_nm": "AI Cache Review",
              //         "user_id": "boopathi.a@dataunveil.com",
              //         "s3_bucket": "dustage-analytics-ui-s3",
              //         "active_image": "https://dustage-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/data-processing-monitor.svg",
              //         "client_key": "2001",
              //         "access_flg": "Y",
              //         "hide_flg": "N",
              //         "hover_image": "https://dustage-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/Group.svg",
              //         "logo_image": "https://dustage-analytics-ui-s3.s3.amazonaws.com/assets/svgIcons/module-logo.svg",
              //         "hist_access_flg": "H",
              //         "color_code": [
              //             "#7A00E6"
              //         ]
              //     });
              // }
             
              // sessionStorage.setItem('Scraii_Dashboard',JSON.stringify(dashboard));
            } else {
              if (this.moduleKey == 100119) {
                this.pages = [];
              } else {
                this.pages = [];
              }
              this.appendEmdPage();
              this.appendCaseManagementPages();
            }
            // this.addStaticDashboards();
            this.cdr.detectChanges();
          },
          (err) => {
            console.log(err);
            // Dashboard access has no row for the EMD module, so it answers
            // with an error rather than an empty list. The static tile still
            // has to appear, so inject it on this path too.
            this.appendEmdPage();
            this.appendCaseManagementPages();
            this.cdr.detectChanges();
          }
        )
    );
  }

  // The EMD (Wholesaler) dashboard row, shaped like a real get-dashboard-access
  // record so the tile, bookmark view and anything else reading this list see
  // the same fields they would for an API-backed dashboard. Identity and access
  // come from the constants; client/user fields come from component state.
  private buildEmdPage() {
    return {
      dashboard_key: EMD_DASHBOARD_KEY,
      dashboard_nm: EMD_DASHBOARD_NM,
      work_nm: EMD_DASHBOARD_NM,
      user_id: this.userName,
      s3_bucket: EMD_ASSET_BUCKET,
      active_image: `${EMD_ASSET_BASE}/operation-monitor.svg`,
      client_key: this.clientKey,
      access_flg: "Y",
      hide_flg: "N",
      hover_image: `${EMD_ASSET_BASE}/Group.svg`,
      logo_image: `${EMD_ASSET_BASE}/module-logo.svg`,
      // "H" hides the History button and widens View to full width.
      hist_access_flg: "H",
      color_code: ["#7A00E6"],
    };
  }

  // Guarded variant used on the paths where dashboard access returned nothing
  // usable — a null payload or an outright error — so the tile still appears.
  private appendEmdPage() {
    if (this.moduleKey != SALES_MODULE_KEY) {
      return;
    }

    // The API may have answered with null, an error, or a non-array payload.
    if (!Array.isArray(this.pages)) {
      this.pages = [];
    }

    // getDashboardData runs again on brand selection; do not stack duplicates.
    if (this.pages.some((p: any) => p.dashboard_key === EMD_DASHBOARD_KEY)) {
      return;
    }

    // this.pages.push(this.buildEmdPage());
  }

  // One tile per Case Management screen (FRM_CASE_MANAGEMENT_DASHBOARDS), shaped
  // like a get-dashboard-access row (see buildEmdPage); the picture is the screen's
  // own svg from src/assets/svgIcons.
  private buildCaseManagementPage(dashboard: CaseManagementDashboard) {
    return {
      dashboard_key: dashboard.key,
      dashboard_nm: dashboard.name,
      work_nm: dashboard.name,
      user_id: this.userName,
      s3_bucket: EMD_ASSET_BUCKET,
      active_image: `assets/svgIcons/${dashboard.image}`,
      client_key: this.clientKey,
      access_flg: "Y",
      hide_flg: "N",
      hover_image: `${EMD_ASSET_BASE}/Group.svg`,
      logo_image: `${EMD_ASSET_BASE}/module-logo.svg`,
      hist_access_flg: "H",
      color_code: ["#093868"],
    };
  }

  private appendCaseManagementPages() {
    if (this.moduleKey != FRM_MODULE_KEY) {
      return;
    }
    if (!Array.isArray(this.pages)) {
      this.pages = [];
    }
    for (const dashboard of FRM_CASE_MANAGEMENT_DASHBOARDS) {
      // getDashboardData runs again on brand selection; do not stack duplicates.
      if (!this.pages.some((p: any) => p.dashboard_key === dashboard.key)) {
        this.pages.push(this.buildCaseManagementPage(dashboard));
      }
    }
  }

  // A Case Management tile opens its screen in the lazy CaseManagementModule at
  // `:module/case-management/<route>`. The screen's shell titles the page, and the
  // logo comes back to this module's dashboard list. ds_key travels as it does for
  // every dashboard: without it the topnav takes the screen for the module's own
  // landing page and hides the back arrow and the page name.
  openCaseManagementPage(dashboard: CaseManagementDashboard) {
    let dashboardDetail = {
      dashboard_nm: dashboard.name,
      dashboard_key: dashboard.key,
    };
    sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail));

    this.navigationService.routerNavigate(
      `dashboard/${this.moduleName}/case-management/${dashboard.route}`,
      { cl_key: this.clientKey, md_key: this.moduleKey, ds_key: dashboard.key }
    );
  }
  // Send every dummy / static dashboard through the shared ":module/static"
  // route instead of the dynamic widget pages. The dashboard_key rides along in
  // ds_key, and StaticDashboardHostComponent uses it to mount the component
  // registered for that key.
  //
  // hist_flg travels the same way it does on the dynamic path: the card's two
  // buttons are Live and History, and it is the only thing that tells them
  // apart. A static dashboard that reads it can render a different view for
  // each (DPM-Static: daily tiles for Live, month calendars for History).
  openStaticPage(page: any, hist_flg?: any) {
    let dashboardDetail = {
      dashboard_nm: page.dashboard_nm,
      dashboard_key: page.dashboard_key,
    };
    sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail));

    // Opening a static dashboard from its card starts a fresh visit: the screen
    // drops the filter selection it persisted and comes up on its defaults. The
    // dynamic path above does the same thing a few lines down in openPage()
    // (clearTimeCycleFilter + the session keys it removes); this is that, for the
    // state a static screen keeps instead. See markStaticDashboardEntry.
    markStaticDashboardEntry(page.dashboard_key);

    let query: any = {
      cl_key: this.clientKey,
      md_key: this.moduleKey,
      ds_key: page.dashboard_key,
    };

    if (hist_flg) {
      query["hist_flg"] = hist_flg;
    }

    this.navigationService.routerNavigate(
      `dashboard/${this.moduleName}/static`,
      query
    );
  }

  openPage(page: any, hist_flg?: any) {
    // Above the static short-circuit, so it covers BOTH paths: opening any
    // dashboard card is an explicit "start here", and the static screens keep
    // their dynamic filters (Brand) in the user state rather than in a filter
    // widget. Without this a static screen reached after a trip through a
    // dynamic dashboard would come up on a brand chosen two pages ago.
    // userMenuModuleHandle() does the same on a module click.
    this.userActivityService.clearStaticFilters();

    const caseManagement = FRM_CASE_MANAGEMENT_DASHBOARDS.find(
      (d) => d.key === String(page?.dashboard_key)
    );
    if (caseManagement) {
      this.openCaseManagementPage(caseManagement);
      return;
    }

    // Dummy / static dashboards load their own template - short-circuit the
    // dynamic page flow below.
    if (isStaticDashboardKey(page?.dashboard_key)) {
      this.openStaticPage(page, hist_flg);
      return;
    }

    sessionStorage.removeItem('selectedJSONSeq');
    sessionStorage.removeItem("source_patient_id");
    sessionStorage.removeItem("tbl_name_suffix_non_frm");
    sessionStorage.removeItem("navDetailInfo");


    // reset the Time Cycle filter to default when we navigate to new page
    this.userActivityService.clearTimeCycleFilter();
    /////////////////////////////////////

    let dashboardDetail = {
      dashboard_nm: page.dashboard_nm,
      work_nm: page.work_nm,
      dashboard_key: page.dashboard_key,
    };
    sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail));
    this.userActivityService.setData({ pageTab: 0 });
    this.checkFlag = true;
    this.filterService.sliderValue = 1;

    page.brand_json_flg = 'Y';

    let query: any = {
      tab_id: 0,
      cl_key: this.clientKey,
      md_key: this.moduleKey,
      ds_key: page.dashboard_key || page.work_key,
    };

    if (hist_flg) {
      query["hist_flg"] = hist_flg;
    }

    this.widgetService.pageHeaderWidgets = [];

    // Keyed on the tile, not the module: Sales also has real API-backed
    // dashboards, and those must still route to PagesComponent.
    if (page.dashboard_key == EMD_DASHBOARD_KEY) {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/emd-dashboard`,
        query
      );
    } else if (this.moduleKey == 100119) {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/${"direct"}/${page.dashboard_nm}`,
        query
      );
    } else {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/${"page"}`,
        query
      );
    }
    // this.route.navigate([`dashboard/${this.clientKey}/${this.moduleKey}/${page.dashboard_key || page.work_key}`]);
  }

  openHistoryPage(page: any) {
    this.openPage(page, "H");
  }

  getWorknames() {
    this.dataService.getWorkList().subscribe((req) => {
      this.DbPages = req;
    });
  }

  getBrandName() {
    let url = "kpi/get-brand-filter";
    this.filterService
      .loadData("post", url, "client_key", "")
      .subscribe((res: any) => {
        this.brandKeyData = res ? res : [];
      });
  }

  setBrandKey(brand: any) {
    // debugger
    if (brand) {
      sessionStorage.setItem("brandKeyForFilters", JSON.stringify(brand));
      // sessionStorage.setItem("brandName", brand);
      this.getDashboardData();
      this.checkFlag = true;

      this.clientLogo = this.filterService.getBrandLogo({ brand_key: brand });
    }
  }

  onFilterTextBoxChanged($event: any) {
    return ($event.target as HTMLInputElement).value;
  }

  selectedWork: any;

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
